<template>
	<ui-modal
		icon="fal fa-id-card"
		title="Campo de Pagamento"
		:load-success="loader.modalSuccess"
		:load="loader.modalLoading"
		:name="modalName"
	>
		<template>
			<div v-show="loader.body" class="loading-area">
				<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
			</div>

			<div v-show="!loader.body" class="body-modal">
				<div class="grid-50">
					<ui-select-2
						v-model="form.field"
						:data="modalOptions.field"
						:search="false"
						:showFooter="false"
						label="Campo Personalizado:"
						item-label="label"
						align="left"
						group-by="type"
						return-value="value"
					/>

					<ui-select-2
						v-model="form.consider"
						:data="modalOptions.consider"
						:search="false"
						:showFooter="false"
						label="Considerar como:"
						item-label="label"
						return-value="value"
					/>
				</div>
				<div class="grid-50">
					<ui-select-2
						v-model="form.type"
						:data="modalOptions.type"
						:search="false"
						:showFooter="false"
						label="Tipo:"
						item-label="label"
						return-value="value"
					/>
					<ui-select-2
						v-model="form.show"
						:data="modalOptions.show"
						:search="false"
						:showFooter="false"
						label="Exibir quando:"
						item-label="label"
						return-value="value"
					/>
				</div>
			</div>
		</template>

		<template #footer>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit"
				>Criar Campo</ui-button
			>
		</template>
	</ui-modal>
</template>
<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelect2, uiSwitch } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { utilMixin, formMixin, alertMixin } from '@/mixins'

	import { configuration } from '@/services/axios'

	const defaultForm = () => ({
		field: null,
		consider: null,
		type: null,
		show: null,
	})

	const defaultOptions = () => ({})

	const defaultLoader = () => ({
		body: true,
		modalLoading: false,
		modalSuccess: false,
	})

	export default {
		name: 'payment-create-modal',

		components: {
			uiModal,
			uiButton,
			uiInput,
			uiSelect2,
			uiSwitch,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		props: {
			/**
			 * Propriedade: name
			 * Deve receber o nome da tabela responsável pelo modal.
			 */
			name: {
				type: String,
				required: true,
			},

			/**
			 * Propriedade: modalName
			 * Deve receber o nome que será declarado para o modal.
			 */
			modalName: {
				type: String,
				required: true,
			},

			/**
			 * Propriedade: modalOptions
			 * Deve receber um objeto com as opções que serão passadas
			 * para os Selects2 do modal: field, consider, type e show.
			 */
			modalOptions: {
				type: Object,
				required: false,
			},

			/**
			 * Propriedade: proposalSettings
			 * Deve receber um objeto com o objeto proposalSettings mais
			 * recente. Utilizado na requisição de adição de campo.
			 */
			proposalSettings: {
				type: Object,
				required: true,
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				options: { ...defaultOptions() },
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		created() {
			this.$root.$on(`modal-open-${this.modalName}`, () => {
				this.reset()
				this.loader.body = false
				this.$mx_copyOldForm()
			})
		},

		destroyed() {
			this.$root.$off(`modal-open-${this.modalName}`)
		},

		computed: {
			canSubmit() {
				return !this.loader.body && this.$mx_isFormChanged && this.allSelected
			},

			validatePayment() {
				return {
					consider: this.form.consider,
					field: `${this.form.field}`,
					type: this.form.type,
					show: this.form.show,
				}
			},

			allSelected() {
				let allSelected = true
				for (let select in this.form) {
					if (!this.$mx_hasValue(this.form[select])) allSelected = false
				}
				return allSelected
			},
		},

		methods: {
			closeModal() {
				this.$root.$emit(`modal-close-${this.modalName}`)
				this.loader.body = true
			},

			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
			},

			/**
			 * Método: submit()
			 * Trata os loaders, atualiza o objeto o proposalSettings com o novo
			 * campo de pagamento montado no modal e faz a requisição.
			 */
			async submit() {
				try {
					this.loader.modalLoading = true

					const proposal = this.$mx_copyObject(this.proposalSettings)
					proposal.payment.push(this.validatePayment)

					await configuration.updateConfig('proposalSettings', {
						value_long: proposal,
					})

					setTimeout(() => {
						this.$root.$emit(`${this.name}:update`)
						this.loader.modalSuccess = true
						setTimeout(() => {
							this.closeModal()
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.modalSuccess = false
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
